module.exports = __webpack_public_path__ + "img/amex.f3db753f.jpg";